// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_U_3","cls2":"ClaimDetails-cls2_A-v ClaimDetails-cls1_U_3"};